import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * PrivateRoute — guards routes behind auth + optional permission check.
 *
 * Props:
 *   component    — the page component to render
 *   permissionKey — (optional) permission key string; if provided, the user must
 *                   have this key in their permissions array to access the route.
 *                   Without it, any logged-in user can access the route.
 */
export default function PrivateRoute({ component: Component, permissionKey, ...rest }) {
  const { isLoggedIn, hasPermission } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isLoggedIn) return <Redirect to="/login" />;
        if (!hasPermission(permissionKey)) return <Redirect to="/dashboard" />;
        return <Component {...props} />;
      }}
    />
  );
}